import { createContext, useContext, useState, useCallback } from "react";

const UnitContext = createContext(null);

export function UnitProvider({ children }) {
  const [tempUnit, setTempUnitState] = useState(() => localStorage.getItem("envisafe_temp_unit") || "F");

  const setTempUnit = useCallback((u) => {
    setTempUnitState(u);
    localStorage.setItem("envisafe_temp_unit", u);
  }, []);

  const toggleTempUnit = useCallback(() => {
    setTempUnitState((prev) => {
      const next = prev === "F" ? "C" : "F";
      localStorage.setItem("envisafe_temp_unit", next);
      return next;
    });
  }, []);

  return (
    <UnitContext.Provider value={{ tempUnit, setTempUnit, toggleTempUnit }}>{children}</UnitContext.Provider>
  );
}

export const useUnit = () => useContext(UnitContext);
